module.exports = __webpack_public_path__ + "img/logo.ec2f382c.png";